import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class RealtimeService {
    constructor(private http: HttpClient, @Inject('ENV') private env: any) {}

    fetchShapesByTripId(trip_id) {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/trips/${trip_id}/shapes`;
        return this.http.get(url);
    }
}
